import { useNetworkRequest } from '@mp/hooks/useNetworkRequest';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@medely/ui-kit';

type SchedulingPayloadProps = {
  professional_screening: {
    calendly_scheduled_event_uri: string;
    calendly_scheduled_event_invitee_uri: string;
    reason: string;
    screening_type: string;
  };
};

export const useCalendlySchedulingMutations = () => {
  const { axios } = useNetworkRequest();
  const toast = useToast();
  const queryClient = useQueryClient();

  const { mutate: schedulingCompletedMutation, isPending } = useMutation(
    (payload: SchedulingPayloadProps) =>
      axios.post('v3/professional/professional_screenings', payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['GetProfessionalTodos']);
        queryClient.invalidateQueries(['currentUser']);
        toast.success('Thank you for scheduling your phone screening!');
      },
      onError: (e: { response: { data: { message: string } } }) => {
        const errorMessage = e?.response?.data?.message;
        toast.error(errorMessage ?? 'Error submitting scheduling, please try again');
      },
    },
  );

  return { schedulingCompletedMutation, isLoading: isPending };
};
